export const countryDataByCountryCode = (
  countriesData: intlTelInput.CountryData[],
  countryId?: string | null
) =>
  countryId === 'MOCK'
    ? {name: 'MOCK', iso2: 'MOCK', dialCode: 'MOCK'}
    : countriesData.find((countryData) => countryData.iso2.toUpperCase() === countryId)
